var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"wheel":_vm.handleWheel}},[_c('PCNavbar',{staticClass:"menuDivHome",class:_vm.menuState == 'down'?'scrollDownCss':'scrollUpCss',attrs:{"selectIndex":"1"}}),_c('MobileNavBar',{attrs:{"currentActive":0}}),_c('CarouselHome'),_c('FirstHome'),_c('SecondHome'),_c('ThirdHome')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }